module.exports = __webpack_public_path__ + "r-v3/img/ml_31_01.e298bcd3.jpg";